import { css } from '@linaria/core';

export const Icon = css`
	overflow: hidden;
	border-radius: 100%;
	margin-right: 8px;
	object-fit: contain;
	object-position: center;
`;
